import { RESET_STATE } from 'store/global/actions';

import { DESK_STATUS_ACTION_TYPE } from '../actions';
import { EMPTY_DESK_STATUS } from '../marginCenter.constants';

const initialState = EMPTY_DESK_STATUS;

const deskStatusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DESK_STATUS_ACTION_TYPE.GET_DESK_STATUS:
      return payload ?? initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default deskStatusReducer;
